var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.linkClass},[_c('a',{attrs:{"href":_vm.link.url,"target":_vm.link.target}},[_vm._v("\n    "+_vm._s(_vm.link.label)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }